import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {YamlMenuFunzionalita} from "@model";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'external-side-menu',
  templateUrl: './external-side-menu.component.html',
  styleUrls: ['./external-side-menu.component.scss'],
  animations : [
    trigger('slideInOut', [
      state('in', style({ height: '*', opacity: 1, transform: 'translateY(2)' })),
      state('out', style({ height: '0px', opacity: 0, transform: 'translateY(-10)', overflow: 'hidden' })),
      transition('in => out', animate('300ms ease-in-out')),
      transition('out => in', animate('300ms ease-in-out'))
    ])
  ]
})
export class ExternalSideMenuComponent implements OnChanges{
  itemSelected: YamlMenuFunzionalita;
  @Input() items: YamlMenuFunzionalita[];
  @Output() changeContent = new EventEmitter<any>();
  selectedIndex: number = 1;

  ngOnChanges() {
    if(this.items) {
      this.itemSelected = sessionStorage.getItem('currentPage') ? JSON.parse(sessionStorage.getItem('currentPage') ?? '{}') : this.items[0];
    }
  }

  loadContent(value: YamlMenuFunzionalita) {
    sessionStorage.setItem('currentPage',JSON.stringify(value));
    this.changeContent.emit(value);
    this.itemSelected = value;
    this.selectedIndex = value.id;
  }

  isActive(item:any) {
    return this.itemSelected.id === item.id;
  };
}
